// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from '../../generated-types'

import gql from 'graphql-tag'
import * as Urql from 'urql'
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>
export type DeclineModalDeclineReasonsQueryVariables = Types.Exact<{
  [key: string]: never
}>

export type DeclineModalDeclineReasonsQuery = {
  __typename?: 'Query'
  declineReasons: Array<{
    __typename?: 'DeclineReason'
    text: string
    id: string
  }>
}

export const DeclineModalDeclineReasonsDocument = gql`
  query DeclineModalDeclineReasons {
    declineReasons {
      text
      id
    }
  }
`

export function useDeclineModalDeclineReasonsQuery(
  options?: Omit<
    Urql.UseQueryArgs<DeclineModalDeclineReasonsQueryVariables>,
    'query'
  >
) {
  return Urql.useQuery<DeclineModalDeclineReasonsQuery>({
    query: DeclineModalDeclineReasonsDocument,
    ...options,
  })
}
